import './tailwind.css'
import 'flowbite';
import './style.css'
import { Carousel } from 'flowbite';
import EmblaCarousel from 'embla-carousel';
import EmblaCarouselAutoplay from 'embla-carousel-autoplay';

//cookie helper functions
function getCookie(name) {
  let match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + "; path=/; SameSite=Strict" + expires;
}

//close mobile menu on click outside menu
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("navbar-dropdown");
  const menuToggle = document.querySelector(".hamburger");
  
  if (!menu || !menuToggle) return;

  function closeMenu(event) {
    if (!menu.contains(event.target) && !menuToggle.contains(event.target)) {
      menu.classList.add("hidden");
      menuToggle.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", closeMenu);
    }
  }
  
  menuToggle.addEventListener("click", function () {
    const isOpen = !menu.classList.contains("hidden");

    if (isOpen) {
      menu.classList.add("hidden");
      menuToggle.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", closeMenu);
    } else {
      menu.classList.remove("hidden");
      menuToggle.setAttribute("aria-expanded", "true");
      document.addEventListener("click", closeMenu);
    }
  });
});

//focus cursor on clicking search icon
window.focusSearchInput = function() {
  setTimeout(() => {
    const searchInput = document.getElementById("search-mobile");
    if (searchInput) {
      searchInput.focus();
    }
  }, 100); 
}
  
//dark mode: use system settings for dark mode, allow user to overrule and set cookie to store it
var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
  
function getDarkModeCookie() {
  const match = document.cookie.match(/(^| )darkMode=([^;]+)/);
  return match ? match[2] === 'enabled' : null;
}

function setDarkModeCookie(isDark) {
  document.cookie = `darkMode=${isDark ? 'enabled' : 'disabled'}; path=/; max-age=31536000`;
}
  
function getSystemDarkMode() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}
  
function updateDarkModeUI(isDarkMode) {
  document.documentElement.classList.toggle('dark', isDarkMode);
  // Ensure only one icon is visible
  if (themeToggleDarkIcon && themeToggleLightIcon) {
    if (isDarkMode) {
      themeToggleDarkIcon.classList.remove('hidden');
      themeToggleLightIcon.classList.add('hidden');
    } else {
      themeToggleDarkIcon.classList.add('hidden');
      themeToggleLightIcon.classList.remove('hidden');
    }
  }
  
  // Update TinyMCE dark mode if editor exists
  if (window.tinymce) {
    window.tinymce.editors.forEach(editor => {
      editor.getBody().classList.toggle('dark', isDarkMode);
    });
  }
}
  
function getDarkModeStatus(){
  return getDarkModeCookie() ?? getSystemDarkMode()
}

function applyDarkModeSetting() {
  const userPreference = getDarkModeCookie();
  const isDarkMode = userPreference !== null ? userPreference : getSystemDarkMode();
  const alreadyDark = document.documentElement.classList.contains('dark');
  if (alreadyDark !== isDarkMode) {
    updateDarkModeUI(isDarkMode);
  } else {
    if (themeToggleDarkIcon && themeToggleLightIcon) {
      if (isDarkMode) {
        themeToggleDarkIcon.classList.remove('hidden');
        themeToggleLightIcon.classList.add('hidden');
      } else {
        themeToggleDarkIcon.classList.add('hidden');
        themeToggleLightIcon.classList.remove('hidden');
      }
    }
  }
  updateFloorAdRetries(isDarkMode);
}

function updateFloorAdRetries(isDarkMode){
  setTimeout(() => {
    for (let i = 0; i < 5; i++){
      setTimeout(() => {
        updateFloorAd(isDarkMode);
      }, 500);
    }
  }, 500);
}

function updateFloorAd(isDarkMode){
  if (document.getElementById(floor_id)){
    const floorAd = document.getElementById(floor_id);
    if (isDarkMode){
      floorAd.style.backgroundColor = "var(--color-zinc-900)";
    } else {
      floorAd.style.backgroundColor = "var(--color-white)";
    }
  }
}

window.toggleDarkMode = function() {
  const isDarkMode = !document.documentElement.classList.contains('dark');
  setDarkModeCookie(isDarkMode);
  updateDarkModeUI(isDarkMode);
  updateFloorAd(isDarkMode);
}

document.addEventListener('DOMContentLoaded', applyDarkModeSetting);

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  if (getDarkModeCookie() === null) {
    applyDarkModeSetting();
  }
});

//resize Tailwind carousel to fit the image
window.resetCarousel = function(carousel_id) {
  let carouselId = '#' + carousel_id;
  const carousel = document.querySelector(carouselId);
  if (carousel) {
    const parentWidth = carousel.offsetWidth;
    const parentHeight = carousel.offsetHeight;
    const images = carousel.querySelectorAll('.carousel-item img');
    let maxWidth = 0;
    let maxHeight = 0;
    let displayHeight = 0;
    let calculatedWidth = 0;
    let calculatedHeight = 0;

    images.forEach(img => {
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth > parentWidth) {
        calculatedWidth = parentWidth;
        calculatedHeight = (parentWidth / imgWidth) * imgHeight;
      } else {
        calculatedWidth = imgWidth;
        calculatedHeight = imgHeight;
      }

      if (calculatedHeight > displayHeight) {
        displayHeight = calculatedHeight
      }
      if (imgWidth > maxWidth) {
          maxWidth = imgWidth;
      }
      if (imgHeight > maxHeight) {
          maxHeight = imgHeight;
      }
    });
    if (maxWidth > 0) {
        carousel.style.maxWidth = `${maxWidth}px`;
    }
    if (maxHeight > 0) {
      carousel.style.maxHeight = `${maxHeight}px`;
    }
    if (displayHeight > 0) {
      carousel.querySelector('.carousel').style.height = `${displayHeight}px`;
    }
  }
};

// embla carousel
const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
    else prevBtn.setAttribute('disabled', 'disabled')

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
    else nextBtn.setAttribute('disabled', 'disabled')
  }

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState)

  return () => {
    prevBtn.removeAttribute('disabled')
    nextBtn.removeAttribute('disabled')
  }
}

const addPrevNextBtnsClickHandlers = (
  emblaApi,
  prevBtn,
  nextBtn,
  onButtonClick
) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev()
    if (onButtonClick) onButtonClick(emblaApi)
  }
  const scrollNext = () => {
    emblaApi.scrollNext()
    if (onButtonClick) onButtonClick(emblaApi)
  }
  prevBtn.addEventListener('click', scrollPrev, false)
  nextBtn.addEventListener('click', scrollNext, false)

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  )

  return () => {
    removeTogglePrevNextBtnsActive()
    prevBtn.removeEventListener('click', scrollPrev, false)
    nextBtn.removeEventListener('click', scrollNext, false)
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Embla Carousels
  const carousels = document.querySelectorAll('.embla');
  if (carousels.length > 0) {
    carousels.forEach(carousel => {
      const options = { loop: true, duration: 25  };
      const autoplay = EmblaCarouselAutoplay({
        delay: 4000,
        jump: false,
        stopOnInteraction: false,
        stopOnMouseEnter: true
      });
      const plugins = [autoplay];
      const embla = EmblaCarousel(carousel, options, plugins);

      // Add navigation buttons if they exist
      const prevBtn = carousel.querySelector('.embla__button--prev');
      const nextBtn = carousel.querySelector('.embla__button--next');
      
      if (prevBtn && nextBtn) {
        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
          embla,
          prevBtn,
          nextBtn
        );
      }
    });
  }
});

//make cta buttons the same width as the longest button
document.addEventListener('DOMContentLoaded', function() {
  var width = 0;
  var ctas = document.querySelectorAll('.cta-button')
  ctas.forEach(cta => {
	if (width < cta.firstElementChild.offsetWidth){
    width = cta.firstElementChild.offsetWidth
}
});
ctas.forEach(cta => {cta.firstElementChild.style.width = width + 'px'})
})


//prefill search query in search field
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const queryValue = urlParams.get('q');
  if (queryValue) {
    const desktopSearchInput = document.getElementById('search-navbar');
    const mobileSearchInput = document.getElementById('search-navbar-mobile');

    if (desktopSearchInput) {
      desktopSearchInput.value = queryValue;
    }

    if (mobileSearchInput) {
      mobileSearchInput.value = queryValue;
    }
  }
});


//if div #side is visible, make it sticky
document.addEventListener('DOMContentLoaded', () => {
  const sideAd = document.getElementById('side');
  const footer = document.querySelector('footer');

  if (!sideAd) {
    return;
  }

  // We need the original position to know WHEN to make it sticky.
  let sideAdOriginalTop = null;
  let sideAdOriginalLeft = null;
  let sideAdOriginalWidth = null;
  
  const sideScrollHandler = () => {
    // Abort if screen is too small, letting CSS handle the element.
    if (window.innerWidth < 1122) {
      sideAd.classList.remove('side-ad-sticky');
      sideAd.style.top = '';
      sideAd.style.left = '';
      sideAd.style.width = '';
      return;
    }

    // First time we are on a wide enough screen, calculate the div's geometry.
    if (sideAdOriginalTop === null) {
      sideAdOriginalTop = sideAd.offsetTop;
      sideAdOriginalLeft = sideAd.getBoundingClientRect().left;
      sideAdOriginalWidth = sideAd.offsetWidth;
    }

    // Check if we should be sticky based on original position.
    if (window.scrollY >= sideAdOriginalTop && (window.scrollY + 632) < footer.offsetTop){
      // start at sideAd.offsetTop.
      sideAd.classList.add('side-ad-sticky');
      sideAd.style.top = '0px';
      sideAd.style.left = `${sideAdOriginalLeft}px`;
      sideAd.style.width = `${sideAdOriginalWidth}px`;
    } else if (window.scrollY >= sideAdOriginalTop && (window.scrollY + 632) > footer.offsetTop) {
      sideAd.classList.add('side-ad-sticky');
      sideAd.style.top = footer.offsetTop - (window.scrollY + 632) + 'px';
      sideAd.style.left = `${sideAdOriginalLeft}px`;
      sideAd.style.width = `${sideAdOriginalWidth}px`;
    } else {
      sideAd.classList.remove('side-ad-sticky');
      sideAd.style.top = '';
      sideAd.style.left = '';
      sideAd.style.width = '';
    }
};

  const handleResize = () => {
      sideAd.classList.remove('side-ad-sticky');
      sideAd.style.top = '';
      sideAd.style.left = '';
      sideAd.style.width = '';
      // Reset so geometry gets recalculated on the next scroll.
      sideAdOriginalTop = null;
      sideAdOriginalLeft = null;
      sideAdOriginalWidth = null;
      sideScrollHandler(); // Rerun logic immediately after resize
  };

  window.addEventListener('scroll', sideScrollHandler);
  window.addEventListener('resize', handleResize);
});
